/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
import { AppConfigGen } from './AppConfigGen'
export const AppConfig = {
  ...AppConfigGen,
  "COMPANY_ADDRESS": "No.304, Anand NR Onyx, 4th Floor, Sarakki, 100 Feet Road, 15th Cross, 5th Phase Extenision, JP Nagar, Bengaluru, Karnataka - 560078",
  "VERSION": "1.0.35",
  "SUPPORT_PHONE": "+919663049747",
  "WHATSAPP_PHONE": "https://wa.me/919663049747?text=",
  "CLIENT_DASHBOARD": "/",
  "DEFAULT_CURRENCY_SYMBOL": "\u20B9"
}



// WEBPACK FOOTER //
// ./src/AppConfig.js